var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Client Management Settings")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Select Client")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.ClientOTPlist,
      "id": "Clientlist",
      "name": "Clientlist",
      "placeholder": "Select Clients",
      "label": "clientName",
      "track-by": "clientId",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    on: {
      "select": _vm.onSelectClient
    },
    model: {
      value: (_vm.selectedClients),
      callback: function($$v) {
        _vm.selectedClients = $$v
      },
      expression: "selectedClients"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("MPS Print Disabled Clients")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mpsPrintDisabledClients),
      expression: "mpsPrintDisabledClients"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "mpsPrintDisabledClients",
      "name": "mpsPrintDisabledClients"
    },
    domProps: {
      "checked": Array.isArray(_vm.mpsPrintDisabledClients) ? _vm._i(_vm.mpsPrintDisabledClients, "1") > -1 : (_vm.mpsPrintDisabledClients)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.mpsPrintDisabledClients,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mpsPrintDisabledClients = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.mpsPrintDisabledClients = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mpsPrintDisabledClients = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "mpsdisableviewall",
      "name": "mpsdisableviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('mpsprintdisabled')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Client Reference Number")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClientReferenceNolist),
      expression: "ClientReferenceNolist"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ClientReferenceNolist",
      "name": "ClientReferenceNolist"
    },
    domProps: {
      "checked": Array.isArray(_vm.ClientReferenceNolist) ? _vm._i(_vm.ClientReferenceNolist, "1") > -1 : (_vm.ClientReferenceNolist)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ClientReferenceNolist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ClientReferenceNolist = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ClientReferenceNolist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ClientReferenceNolist = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "clientreferenceviewall",
      "name": "clientreferenceviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('clientreferenceno')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Reference Number")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReferenceNolist),
      expression: "ReferenceNolist"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ReferenceNolist",
      "name": "ReferenceNolist"
    },
    domProps: {
      "checked": Array.isArray(_vm.ReferenceNolist) ? _vm._i(_vm.ReferenceNolist, "1") > -1 : (_vm.ReferenceNolist)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ReferenceNolist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ReferenceNolist = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ReferenceNolist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ReferenceNolist = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "referenceviewall",
      "name": "referenceviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('referenceno')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Disable Weight & Dimensions")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClientsForDisabledWt),
      expression: "ClientsForDisabledWt"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ClientsForDisabledWt",
      "name": "ClientsForDisabledWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.ClientsForDisabledWt) ? _vm._i(_vm.ClientsForDisabledWt, "1") > -1 : (_vm.ClientsForDisabledWt)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ClientsForDisabledWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ClientsForDisabledWt = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ClientsForDisabledWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ClientsForDisabledWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "disablewtviewall",
      "name": "disablewtviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('clientdisabledwt')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("OTP Based Deliveries")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OTPBasedDelivery),
      expression: "OTPBasedDelivery"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "OTPBasedDelivery",
      "name": "OTPBasedDelivery"
    },
    domProps: {
      "checked": Array.isArray(_vm.OTPBasedDelivery) ? _vm._i(_vm.OTPBasedDelivery, "1") > -1 : (_vm.OTPBasedDelivery)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.OTPBasedDelivery,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.OTPBasedDelivery = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.OTPBasedDelivery = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.OTPBasedDelivery = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "otpviewall",
      "name": "otpviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('otpbaseddelivery')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("MPS Sticker Print Customisation")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "customisempssticker",
      "name": "customisempssticker",
      "title": "Customise MPS sticker parameter with this setting"
    },
    on: {
      "click": function($event) {
        _vm.handler('mpscopy')
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "mpsstickerviewall",
      "name": "mpsstickerviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('mpscopy')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("AWB LR Copy Customisation")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "customiseawbcopy",
      "name": "customiseawbcopy",
      "title": "Customise AWB LR copy parameter with this setting"
    },
    on: {
      "click": function($event) {
        _vm.handler('awbcopy')
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "awblrcopyviewall",
      "name": "awblrcopyviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('awbcopy')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Consignee code print on MPS stickers")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConsigneeCodeOnMps),
      expression: "ConsigneeCodeOnMps"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ConsigneeCodeOnMps",
      "name": "ConsigneeCodeOnMps"
    },
    domProps: {
      "checked": Array.isArray(_vm.ConsigneeCodeOnMps) ? _vm._i(_vm.ConsigneeCodeOnMps, "1") > -1 : (_vm.ConsigneeCodeOnMps)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ConsigneeCodeOnMps,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ConsigneeCodeOnMps = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ConsigneeCodeOnMps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ConsigneeCodeOnMps = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "ConsigneeCodeOnMpsViewAll",
      "name": "ConsigneeCodeOnMpsViewAll",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('consigneecodeonmpssticker')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Reliance Secondary Client")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RelianceSecondaryClient),
      expression: "RelianceSecondaryClient"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "RelianceSecondaryClient",
      "name": "RelianceSecondaryClient"
    },
    domProps: {
      "checked": Array.isArray(_vm.RelianceSecondaryClient) ? _vm._i(_vm.RelianceSecondaryClient, "1") > -1 : (_vm.RelianceSecondaryClient)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.RelianceSecondaryClient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.RelianceSecondaryClient = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.RelianceSecondaryClient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.RelianceSecondaryClient = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "RelianceSecondaryClientViewAll",
      "name": "RelianceSecondaryClientViewAll",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('realiancesecondaryclient')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Capture Proof Of Pickup")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ProofOfPickup),
      expression: "ProofOfPickup"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "proofofpickup",
      "name": "proofofpickup"
    },
    domProps: {
      "checked": Array.isArray(_vm.ProofOfPickup) ? _vm._i(_vm.ProofOfPickup, "1") > -1 : (_vm.ProofOfPickup)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ProofOfPickup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ProofOfPickup = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ProofOfPickup = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ProofOfPickup = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "ProofOfPickupViewAll",
      "name": "ProofOfPickupViewAll",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('poprequired')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Enable Global Pickup")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "globalPickupEdit",
      "name": "globalPickupEdit",
      "title": "Global Pickup "
    },
    on: {
      "click": function($event) {
        _vm.GlobalPickupPincode('pincode')
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "globalPickupViewAll",
      "name": "globalPickupViewAll",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClientforGlobalPickup('pincode')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Bypass AWB Verification")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableverification),
      expression: "enableverification"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "enableverification",
      "name": "enableverification"
    },
    domProps: {
      "checked": Array.isArray(_vm.enableverification) ? _vm._i(_vm.enableverification, "1") > -1 : (_vm.enableverification)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableverification,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableverification = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableverification = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableverification = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "viewenableverification",
      "name": "viewenableverification",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('enableverificationflag')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Block Client Pickup/Delivery")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "clientconfig",
      "name": "clientconfig",
      "title": "Customise Pickup & Delivery of Client with this setting"
    },
    on: {
      "click": function($event) {
        _vm.handler('enableclient')
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "awblrcopyviewall",
      "name": "awblrcopyviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('blockclientcode')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Client Level Pincode Blocking for Booking and Delivery")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "restrictpincode",
      "name": "restrictpincode",
      "title": "Client Level Pincode Blocking for Booking and Delivery"
    },
    on: {
      "click": function($event) {
        _vm.handler('restrictpincode')
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "restrictpincodeviewall",
      "name": "restrictpincodeviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('restrictserviceability')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Enable Global Dropoff")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "globalDropoffEdit",
      "name": "globalDropoffEdit",
      "title": "Global Drop off "
    },
    on: {
      "click": function($event) {
        _vm.GlobalPickupPincode('globaldropoffpincode')
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "globalDropoffViewAll",
      "name": "globalDropoffViewAll",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClientforGlobalPickup('globaldropoffpincode')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("DWS Disable Weight & Dimensions")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClientsForDisableDWS),
      expression: "ClientsForDisableDWS"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ClientsForDisableDWS",
      "name": "ClientsForDisableDWS"
    },
    domProps: {
      "checked": Array.isArray(_vm.ClientsForDisableDWS) ? _vm._i(_vm.ClientsForDisableDWS, "1") > -1 : (_vm.ClientsForDisableDWS)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ClientsForDisableDWS,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ClientsForDisableDWS = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ClientsForDisableDWS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ClientsForDisableDWS = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "disablewtviewall",
      "name": "disablewtviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('clientdisabledws')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Client MPS Enabled for MPS Allocation")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClientsForEnabledMPSAllocation),
      expression: "ClientsForEnabledMPSAllocation"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ClientsForEnabledMPSAllocation",
      "name": "ClientsForEnabledMPSAllocation"
    },
    domProps: {
      "checked": Array.isArray(_vm.ClientsForEnabledMPSAllocation) ? _vm._i(_vm.ClientsForEnabledMPSAllocation, "1") > -1 : (_vm.ClientsForEnabledMPSAllocation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ClientsForEnabledMPSAllocation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ClientsForEnabledMPSAllocation = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ClientsForEnabledMPSAllocation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ClientsForEnabledMPSAllocation = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "disablempsallocationviewall",
      "name": "disablempsallocationviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('clientenablempsallocation')
      }
    }
  }, [_vm._v(" View All")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Dimension visibility in Waybill/LR Copy")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabledimensionvisibilitylrcopy),
      expression: "enabledimensionvisibilitylrcopy"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "enabledimensionvisibilitylrcopy",
      "name": "enabledimensionvisibilitylrcopy"
    },
    domProps: {
      "checked": Array.isArray(_vm.enabledimensionvisibilitylrcopy) ? _vm._i(_vm.enabledimensionvisibilitylrcopy, "1") > -1 : (_vm.enabledimensionvisibilitylrcopy)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enabledimensionvisibilitylrcopy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enabledimensionvisibilitylrcopy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enabledimensionvisibilitylrcopy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enabledimensionvisibilitylrcopy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "viewenabledimensionvisibilitylrcopy",
      "name": "viewenabledimensionvisibilitylrcopy",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('enabledimensionvisibilitylrcopy')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedClients.clientId),
      expression: "selectedClients.clientId"
    }],
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Open Pickup/ Delivery")]), _vm._v(" "), _c('td', [_vm._v("\n                  Surface: "), (_vm.openpickupdelivery.Surface == 1) ? _c('span', [_vm._v("Yes")]) : _vm._e(), (_vm.openpickupdelivery.Surface == 0) ? _c('span', [_vm._v("No")]) : _vm._e(), _c('br'), _vm._v("\n                  Air: "), (_vm.openpickupdelivery.Air == 1) ? _c('span', [_vm._v("Yes")]) : _vm._e(), (_vm.openpickupdelivery.Air == 0) ? _c('span', [_vm._v("No")]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Disabled Proof Of Delivery")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-edit fa-2x",
    staticStyle: {
      "color": "rgb(58, 194, 204)",
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0",
      "id": "disablePod",
      "name": "disablePod",
      "title": "Customize if POD is mandatory"
    },
    on: {
      "click": function($event) {
        _vm.handler('disablePod')
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "DisabledProofOfDeliveryViewAll",
      "name": "DisabledProofOfDeliveryViewAll",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('ispoddisabled')
      }
    }
  }, [_vm._v(" View All ")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Client Enabled for MPS Level Weight Capture")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClientsForMPSLevelWeightCapture),
      expression: "ClientsForMPSLevelWeightCapture"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "ClientsForMPSLevelWeightCapture",
      "name": "ClientsForMPSLevelWeightCapture"
    },
    domProps: {
      "checked": Array.isArray(_vm.ClientsForMPSLevelWeightCapture) ? _vm._i(_vm.ClientsForMPSLevelWeightCapture, "1") > -1 : (_vm.ClientsForMPSLevelWeightCapture)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ClientsForMPSLevelWeightCapture,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ClientsForMPSLevelWeightCapture = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ClientsForMPSLevelWeightCapture = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ClientsForMPSLevelWeightCapture = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "id": "disablempslevelweightcaptureviewall",
      "name": "disablempslevelweightcaptureviewall",
      "title": "View all clients with this setting"
    },
    on: {
      "click": function($event) {
        _vm.getAllClient('clientenablempslevelweightcapture')
      }
    }
  }, [_vm._v(" View All")])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [(_vm.showSaveButton) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "clientmanagement",
      "name": "clientmanagement",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveClientSettings('clientmanagement')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])]) : _vm._e()]), _vm._v(" "), _c('br')], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.ShowClientDetails = false
      }
    },
    model: {
      value: (_vm.ShowClientDetails),
      callback: function($$v) {
        _vm.ShowClientDetails = $$v
      },
      expression: "ShowClientDetails"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Client Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.clientlist), function(data, index) {
    return (_vm.clientlist.length > 0) ? _c('span', [_c('span', {
      staticClass: "clienttag"
    }, [_vm._v(_vm._s(data))])]) : _vm._e()
  }))])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.ShowClientDetailsforglobalpickup = false
      }
    },
    model: {
      value: (_vm.ShowClientDetailsforglobalpickup),
      callback: function($$v) {
        _vm.ShowClientDetailsforglobalpickup = $$v
      },
      expression: "ShowClientDetailsforglobalpickup"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Client and Pincode Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "min-width": "490px",
      "max-width": "490px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Pincodes")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.GlobalPickupClientPincodeData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "min-width": "200px",
        "max-width": "200px"
      }
    }, [_vm._v(_vm._s((data.pincode).join(", ")))])])
  }))])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ShowAwbCopyDetails = false
      }
    },
    model: {
      value: (_vm.ShowAwbCopy),
      callback: function($$v) {
        _vm.ShowAwbCopy = $$v
      },
      expression: "ShowAwbCopy"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.printcopy))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "45%"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "45%"
    }
  }, [_vm._v("Value")])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "height": "55px"
    }
  }, [_c('td', [_vm._v("\n                Field 1\n              ")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookinglabel1),
      expression: "bookinglabel1"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bookinglabel1",
      "id": "bookinglabel1",
      "maxlength": "25",
      "placeholder": "Enter Label"
    },
    domProps: {
      "value": (_vm.bookinglabel1)
    },
    on: {
      "keyup": function($event) {
        _vm.setawbcopy($event, 'field1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookinglabel1 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "position": "relative",
      "left": "0"
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingfield1),
      expression: "bookingfield1"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "bookingfield1",
      "id": "bookingfield1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bookingfield1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setawbcopy($event, 'field1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Field")]), _vm._v(" "), _vm._l((_vm.bookingfieldlist1), function(list) {
    return _c('option', {
      attrs: {
        "disabled": list.disable == 1
      },
      domProps: {
        "value": list.value
      }
    }, [_vm._v("\n                  " + _vm._s(list.key))])
  })], 2)])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "height": "55px"
    }
  }, [_c('td', [_vm._v("\n                Field 2\n              ")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookinglabel2),
      expression: "bookinglabel2"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bookinglabel2",
      "id": "bookinglabel2",
      "maxlength": "25",
      "placeholder": "Enter Label"
    },
    domProps: {
      "value": (_vm.bookinglabel2)
    },
    on: {
      "keyup": function($event) {
        _vm.setawbcopy($event, 'field2')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookinglabel2 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "position": "relative",
      "left": "0"
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingfield2),
      expression: "bookingfield2"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "bookingfield2",
      "id": "bookingfield2"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bookingfield2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setawbcopy($event, 'field2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Field")]), _vm._v(" "), _vm._l((_vm.bookingfieldlist2), function(list) {
    return _c('option', {
      attrs: {
        "disabled": list.disable == 1
      },
      domProps: {
        "value": list.value
      }
    }, [_vm._v(_vm._s(list.key))])
  })], 2)])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "height": "55px"
    }
  }, [_c('td', [_vm._v("\n                Field 3 "), _c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Multiple value parameter."
    }
  })]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookinglabel3),
      expression: "bookinglabel3"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bookinglabel3",
      "id": "bookinglabel3",
      "maxlength": "25",
      "placeholder": "Enter Label"
    },
    domProps: {
      "value": (_vm.bookinglabel3)
    },
    on: {
      "keyup": function($event) {
        _vm.setawbcopy($event, 'field3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookinglabel3 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "position": "relative",
      "left": "0"
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingfield3),
      expression: "bookingfield3"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "bookingfield3",
      "id": "bookingfield3"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bookingfield3 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setawbcopy($event, 'field3')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Field")]), _vm._v(" "), _vm._l((_vm.bookingfieldlist3), function(list) {
    return _c('option', {
      attrs: {
        "disabled": list.disable == 1
      },
      domProps: {
        "value": list.value
      }
    }, [_vm._v(_vm._s(list.key))])
  })], 2)])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "clientmanagement",
      "name": "clientmanagement",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAwbCopyData('clientmanagement')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "awbcopyreset",
      "name": "awbcopyreset",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetAWBCopy
    }
  }, [_vm._v("\n          Reset  "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _c('br')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ShowMpsCopyDetails = false
      }
    },
    model: {
      value: (_vm.ShowMpsCopy),
      callback: function($$v) {
        _vm.ShowMpsCopy = $$v
      },
      expression: "ShowMpsCopy"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.printcopy))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "45%"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "45%"
    }
  }, [_vm._v("Value")])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "height": "55px"
    }
  }, [_c('td', [_vm._v("\n              Field 1\n              ")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingmpslabel1),
      expression: "bookingmpslabel1"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bookingmpslabel1",
      "id": "bookingmpslabel1",
      "placeholder": "Enter Label"
    },
    domProps: {
      "value": (_vm.bookingmpslabel1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookingmpslabel1 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "position": "relative",
      "left": "0"
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingmpsfield1),
      expression: "bookingmpsfield1"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "bookingmpsfield1",
      "id": "bookingmpsfield1",
      "maxlength": "25"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bookingmpsfield1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setmpscopy($event, 'field1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Field")]), _vm._v(" "), _vm._l((_vm.mpsfieldlist1), function(list) {
    return _c('option', {
      attrs: {
        "disabled": list.disable == 1
      },
      domProps: {
        "value": list.value
      }
    }, [_vm._v(_vm._s(list.key))])
  })], 2)])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "height": "55px"
    }
  }, [_c('td', [_vm._v("\n            Field 2\n            ")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingmpslabel2),
      expression: "bookingmpslabel2"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bookingmpslabel2",
      "id": "bookingmpslabel2",
      "maxlength": "25",
      "placeholder": "Enter Label"
    },
    domProps: {
      "value": (_vm.bookingmpslabel2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookingmpslabel2 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "position": "relative",
      "left": "0"
    }
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingmpsfield2),
      expression: "bookingmpsfield2"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "bookingmpsfield2",
      "id": "bookingmpsfield2"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bookingmpsfield2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setmpscopy($event, 'field2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Field")]), _vm._v(" "), _vm._l((_vm.mpsfieldlist2), function(list) {
    return _c('option', {
      attrs: {
        "disabled": list.disable == 1
      },
      domProps: {
        "value": list.value
      }
    }, [_vm._v(_vm._s(list.key))])
  })], 2)])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "mpsstickersave",
      "name": "mpsstickersave",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveMpsStickerData('clientmanagement')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "mpsstickerreset",
      "name": "mpsstickerreset",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetMPSCopy
    }
  }, [_vm._v("\n          Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "ok": function($event) {
        _vm.ShowGlobalPickup = false
      }
    },
    model: {
      value: (_vm.ShowGlobalPickup),
      callback: function($$v) {
        _vm.ShowGlobalPickup = $$v
      },
      expression: "ShowGlobalPickup"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Enable Global Pickup")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "size": "md"
    }
  }, [_c('label', [_vm._v("Pincode")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pincode),
      expression: "pincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verify_pincode'),
      expression: "'verify_pincode'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "pincode",
      "id": "pincode",
      "placeholder": "Enter Pincodes"
    },
    domProps: {
      "value": (_vm.pincode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "saveGlobalPickupData",
      "name": "saveGlobalPickupData",
      "type": "button",
      "disabled": _vm.errors.has('pincode')
    },
    on: {
      "click": function($event) {
        _vm.saveGlobalPickupData('saveGlobalPickupData')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "resetGlobalPickup",
      "name": "resetGlobalPickup",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.resetGlobalPickup('globalpickup')
      }
    }
  }, [_vm._v("\n          Reset  "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ShowGlobalDelivery = false
      }
    },
    model: {
      value: (_vm.ShowGlobalDelivery),
      callback: function($$v) {
        _vm.ShowGlobalDelivery = $$v
      },
      expression: "ShowGlobalDelivery"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Enable Global Delivery")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "size": "md"
    }
  }, [_c('label', [_vm._v("Pincode")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globaldeliverypincode),
      expression: "globaldeliverypincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verify_deliverypincode'),
      expression: "'verify_deliverypincode'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "globaldeliverypincode",
      "id": "globaldeliverypincode",
      "placeholder": "Enter Pincodes"
    },
    domProps: {
      "value": (_vm.globaldeliverypincode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globaldeliverypincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('globaldeliverypincode')),
      expression: "errors.has('globaldeliverypincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('globaldeliverypincode')))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "saveGlobalDeliveryData",
      "name": "saveGlobalDeliveryData",
      "type": "button",
      "disabled": _vm.errors.has('pincode')
    },
    on: {
      "click": function($event) {
        _vm.saveGlobalDeliveryData('saveGlobalDeliveryData')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "resetGlobalDelivery",
      "name": "resetGlobalDelivery",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.resetGlobalPickup('globaldeliver')
      }
    }
  }, [_vm._v("\n          Reset  "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.blockclient = false
      }
    },
    model: {
      value: (_vm.blockclient),
      callback: function($$v) {
        _vm.blockclient = $$v
      },
      expression: "blockclient"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.printcopy))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.blockclient = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Block Pickup")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockpickup),
      expression: "blockpickup"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "blockpickup",
      "name": "blockpickup"
    },
    domProps: {
      "checked": Array.isArray(_vm.blockpickup) ? _vm._i(_vm.blockpickup, "1") > -1 : (_vm.blockpickup)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.blockpickup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.blockpickup = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.blockpickup = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.blockpickup = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1)])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Block Delivery")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "50%",
      "margin-top": "5px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockdelivery),
      expression: "blockdelivery"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "blockdelivery",
      "name": "blockdelivery"
    },
    domProps: {
      "checked": Array.isArray(_vm.blockdelivery) ? _vm._i(_vm.blockdelivery, "1") > -1 : (_vm.blockdelivery)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.blockdelivery,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.blockdelivery = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.blockdelivery = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.blockdelivery = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])])], 1)])])]), _vm._v(" "), _c('tr', {
    staticClass: "highlight"
  }, [_c('td', [_vm._v("Reason")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockclientreason),
      expression: "blockclientreason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('blockclientreason')
    },
    attrs: {
      "rows": 3,
      "id": "blockclientreason",
      "name": "blockclientreason",
      "placeholder": "Enter Reason"
    },
    domProps: {
      "value": (_vm.blockclientreason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.blockclientreason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("Note: Max 500 character.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('blockclientreason')),
      expression: "errors.has('blockclientreason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('blockclientreason')))])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "clientmanagement",
      "name": "clientmanagement",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveBlockClientCodeData('clientmanagement')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "awbcopyreset",
      "name": "awbcopyreset",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetBlockClientCodeData
    }
  }, [_vm._v("\n          Reset  "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.disablepod = false
      }
    },
    model: {
      value: (_vm.disablepod),
      callback: function($$v) {
        _vm.disablepod = $$v
      },
      expression: "disablepod"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center",
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Disabled Proof Of Delivery")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.disablepod = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoadingPod,
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPod = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": ""
    }
  }, [_c('b-form-checkbox', {
    on: {
      "change": function($event) {
        _vm.resetPodDisable(true)
      }
    },
    model: {
      value: (_vm.DisabledProofOfDelivery),
      callback: function($$v) {
        _vm.DisabledProofOfDelivery = $$v
      },
      expression: "DisabledProofOfDelivery"
    }
  }, [_vm._v("Non POD Delivery")])], 1), _vm._v(" "), (_vm.DisabledProofOfDelivery) ? _c('b-form-group', {
    attrs: {
      "label": ""
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.isreuploadpodrequired),
      callback: function($$v) {
        _vm.isreuploadpodrequired = $$v
      },
      expression: "isreuploadpodrequired"
    }
  }, [_vm._v("Delayed POD Upload (Post Delivery)")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isreuploadpodrequired) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "podconfig"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PODPincode),
      expression: "PODPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "PickupPincode",
      "id": "PickupPincode",
      "placeholder": "Enter Pincode",
      "pattern": "^(\\d{6})$",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.PODPincode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PODPincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('podconfig.PickupPincode')),
      expression: "errors.has('podconfig.PickupPincode')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("The Pincode field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "pincodesearch",
      "name": "pincodesearch",
      "type": "button"
    },
    on: {
      "click": _vm.onConsigneeSearch
    }
  }, [_vm._v("Search  "), _c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Select Consignee"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.consigneeList,
      "id": "selectedConsignee",
      "name": "selectedConsignee",
      "placeholder": "Select Consignee",
      "label": "consigneecode",
      "track-by": "consigneecode",
      "multiple": true,
      "scroll": true,
      "hide-selected": true,
      "disabled": _vm.selectAllConsignee,
      "required": ""
    },
    model: {
      value: (_vm.selectedConsignee),
      callback: function($$v) {
        _vm.selectedConsignee = $$v
      },
      expression: "selectedConsignee"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "mt-2"
  }, [_c('b-form-checkbox', {
    on: {
      "change": _vm.selectAllConsigneeFunction
    },
    model: {
      value: (_vm.selectAllConsignee),
      callback: function($$v) {
        _vm.selectAllConsignee = $$v
      },
      expression: "selectAllConsignee"
    }
  }, [_vm._v("Select All Consignee")]), _vm._v(" "), (_vm.selectAllConsignee || _vm.selectedConsignee) ? _c('i', {
    staticClass: "fa fa-plus-circle fa-2x text-primary mt-2",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Add New"
    },
    on: {
      "click": function($event) {
        _vm.addConsigneerow()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.podConfig.length > 0 && _vm.isreuploadpodrequired) ? _c('div', {
    staticClass: "form-group row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Consignee List")]), _vm._v(" "), _c('th', [_vm._v("All Consignee Selected")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.podConfig), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.consigneecodes.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.allconsignee ? 'YES' : 'NO'))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times text-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.removedSelectedRecord(index)
        }
      }
    })])])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveClientSettings('pod')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save ml-1"
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.resetPodDisable
    }
  }, [_vm._v("Reset "), _c('i', {
    staticClass: "fa fa-refresh ml-1"
  })])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ShowGlobalDropoff = false
      }
    },
    model: {
      value: (_vm.ShowGlobalDropoff),
      callback: function($$v) {
        _vm.ShowGlobalDropoff = $$v
      },
      expression: "ShowGlobalDropoff"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Enable Global Dropoff")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "closeclientdetails",
      "name": "closeclientdetails",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeClientDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    attrs: {
      "size": "md"
    }
  }, [_c('label', [_vm._v("Pincode")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globaldropoffpincode),
      expression: "globaldropoffpincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verify_globaldropoffpincode'),
      expression: "'verify_globaldropoffpincode'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "globaldropoffpincode",
      "id": "globaldropoffpincode",
      "placeholder": "Enter Pincodes"
    },
    domProps: {
      "value": (_vm.globaldropoffpincode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globaldropoffpincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('globaldropoffpincode')),
      expression: "errors.has('globaldropoffpincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('globaldropoffpincode')))])], 1), _vm._v(" "), _c('small', {
    staticClass: "form-text",
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    },
    attrs: {
      "id": "remarknote",
      "name": "remarknote"
    }
  }, [_vm._v("Note: Use "), _c('b', [_vm._v("ALL")]), _vm._v(" keyword to enable this feature for all pincodes")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "saveGlobalDropoffData",
      "name": "saveGlobalDropoffData",
      "type": "button",
      "disabled": _vm.errors.has('globaldropoffpincode')
    },
    on: {
      "click": function($event) {
        _vm.saveGlobalDropoffData('saveGlobalDropoffData')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "resetGlobalDropoff",
      "name": "resetGlobalDropoff",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetGlobalDropoff
    }
  }, [_vm._v("\n          Reset  "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-backdrop": true
    },
    on: {
      "ok": function($event) {
        _vm.ShowRestrictedPincodes = false
      }
    },
    model: {
      value: (_vm.ShowRestrictedPincodes),
      callback: function($$v) {
        _vm.ShowRestrictedPincodes = $$v
      },
      expression: "ShowRestrictedPincodes"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Client Level Pincode Blocking for Booking and Delivery")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "CloseShowRestrictedPincodes",
      "name": "CloseShowRestrictedPincodes",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.ShowRestrictedPincodes = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "size": "md"
    }
  }, [_c('div', [_c('label', [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('b-form-group', {
    staticClass: "mt-2"
  }, [_c('b-form-checkbox', {
    on: {
      "change": _vm.selectAllPickupPincodesFunction
    },
    model: {
      value: (_vm.selectAllPickupPincodes),
      callback: function($$v) {
        _vm.selectAllPickupPincodes = $$v
      },
      expression: "selectAllPickupPincodes"
    }
  }, [_vm._v("Select all")])], 1)], 1), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupPincode),
      expression: "pickupPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verify_pincode'),
      expression: "'verify_pincode'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.selectAllPickupPincodes,
      "name": "pickupPincode",
      "id": "pickupPincode",
      "placeholder": "Enter Pickup Pincodes"
    },
    domProps: {
      "value": (_vm.pickupPincode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupPincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "misc"
    }
  }, [_vm._v("Note: Please enter comma separated values for multiple pincodes.")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickupPincode')),
      expression: "errors.has('pickupPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pickupPincode')))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "size": "md"
    }
  }, [_c('div', [_c('label', [_vm._v("Delivery Pincode")]), _vm._v(" "), _c('b-form-group', {
    staticClass: "mt-2"
  }, [_c('b-form-checkbox', {
    on: {
      "change": _vm.selectAllDeliveryPincodesFunction
    },
    model: {
      value: (_vm.selectAllDeliveryPincodes),
      callback: function($$v) {
        _vm.selectAllDeliveryPincodes = $$v
      },
      expression: "selectAllDeliveryPincodes"
    }
  }, [_vm._v("Select all")])], 1)], 1), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryPincode),
      expression: "deliveryPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verify_pincode'),
      expression: "'verify_pincode'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.selectAllDeliveryPincodes,
      "name": "deliveryPincode",
      "id": "deliveryPincode",
      "placeholder": "Enter Delivery Pincodes"
    },
    domProps: {
      "value": (_vm.deliveryPincode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryPincode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "misc"
    }
  }, [_vm._v("Note: Please enter comma separated values for multiple pincodes.")]), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliveryPincode')),
      expression: "errors.has('deliveryPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('deliveryPincode')))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "id": "saveRestrictedPincodes",
      "name": "saveRestrictedPincodes",
      "type": "button",
      "disabled": _vm.errors.has('pickupPincode') || _vm.errors.has('deliveryPincode')
    },
    on: {
      "click": function($event) {
        _vm.saveRestrictedPincodes()
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "id": "resetRestrictedPincodes",
      "name": "resetRestrictedPincodes",
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.resetRestrictedPincodes()
      }
    }
  }, [_vm._v("\n                  Reset  "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('br')])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-356ec8a3","hasScoped":true}!./src/modules/adminsettings/views/configuration/clientManagement/clientmanagementconfiguration.component.html
// module id = 2018
// module chunks = 3